/**
 * Groups admin events by calendar day (Tehran), preserving API sort order (newest first).
 */
export function groupAdminEventsByDay(list) {
  if (!Array.isArray(list) || list.length === 0) {
    return [];
  }

  const groups = [];
  let current = null;

  list.forEach((item) => {
    const dayKey = item.date_day_key || item.date_added || `event-${item.id}`;
    const label = item.date_group_label || item.date_added || dayKey;

    if (!current || current.dayKey !== dayKey) {
      current = { dayKey, label, items: [] };
      groups.push(current);
    }

    current.items.push(item);
  });

  return groups;
}
